// extracted by mini-css-extract-plugin
export default {"headerText":"headerText-JtIs9ojF","row":"row-VassUydy","iconLink":"iconLink-mr36Qg_P","icon":"icon-NaC4O35c"};